module.exports = __webpack_public_path__ + "img/bilge_code_logo_tp.403eda03.png";